import NDACreation from "../../../../src/pages/use-cases/page-content/agreements-and-contracts/nda-creation.md";
import * as React from 'react';
export default {
  NDACreation,
  React
};